//Libs
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";

//Local
import BaseModal from "./BaseModal";
import * as strings from "../strings";
import BaseButtonSecondary from "./BaseButtonSecondary";
import BaseButtonPrimary from "./BaseButtonPrimary";
import { ExistingCraftRecord } from "../models/craft-record";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  workRecord: ExistingCraftRecord;
  handleConfirmRestoreWorkRecord: () => Promise<void>;
  isSubmitting: boolean;
}

export default function ConfirmRestoreWorkRecordDialog(props: Props) {
  const { title, numClosedTasks, numOpenTasks } = props.workRecord;
  const totalWRTasks = numClosedTasks + numOpenTasks;

  const sentence =
    totalWRTasks !== 0 ? `, along with its ${totalWRTasks} task(s),` : ``;

  return (
    <BaseModal
      open={props.isOpen}
      closeModal={props.onClose}
      allowOverflowY={true}
      title={
        <div className="mb-4 flex w-full items-center justify-between rounded-t-lg bg-primary p-8 text-left text-white ">
          <h1 className="inline-flex items-center text-xl font-semibold ">
            {strings.RESTORE_WR_QUESTION}
          </h1>
          <button type="button" onClick={() => props.onClose()}>
            <XMarkIcon
              aria-label="close new requirement form"
              className="h-6 text-white"
            />
          </button>
        </div>
      }
      parentDivStyles="inline-block transform overflow-hidden  max-w-screen-sm rounded-lg bg-white text-left align-middle shadow-xl transition-all"
    >
      <div className="relative flex flex-col space-y-8 p-8 text-lg">
        <div>
          The Work Record{" "}
          <span className="font-medium underline underline-offset-2">
            {title}
          </span>
          {sentence} will be restored. Continue?
        </div>
        <div className="mt-4 flex w-full flex-col items-center justify-between gap-6 xs:flex-row">
          <BaseButtonSecondary
            type="button"
            className="w-full justify-center uppercase xs:w-52"
            onClick={props.onClose}
          >
            {strings.buttons.NO}
          </BaseButtonSecondary>

          <BaseButtonPrimary
            type="submit"
            disabled={props.isSubmitting}
            isBusy={props.isSubmitting}
            busyText={strings.buttons.BUSY_RESTORING}
            onClick={() => props.handleConfirmRestoreWorkRecord()}
            className="w-full justify-center uppercase xs:w-52"
          >
            {strings.buttons.YES}
          </BaseButtonPrimary>
        </div>
      </div>
    </BaseModal>
  );
}
